query analyticsImpressionForCompany($isMasterView: Boolean, $childCompanyId: ID) {
  analyticsImpression: analyticsImpressionForCompany(isMasterView: $isMasterView, childCompanyId: $childCompanyId) {
    overallTotal
    last30DaysTotal
    specificDateTotals {
      date
      count
    }
  }
}
